module.exports = __webpack_public_path__ + "img/ms_my.6b621317.png";